const hasChildren = (node = {}) =>
  node.children && Array.isArray(node.children) && node.children.length;

export default hasChildren;
